import Avatar from 'antd/lib/avatar';
import Space from 'antd/lib/space';
import Tooltip from 'antd/lib/tooltip';
import * as React from 'react';
import { shortCommitHashFromHash } from '../../helpers/displayHelpers';
import {
    releaseStepDetailsContainerModuleStyle,
    antGrey,
    getAvatarColorForName,
    titleStyle,
} from '../styles/globalStyles';
import Text from 'antd/lib/typography/Text';
import { BranchesOutlined } from '@ant-design/icons';
import Divider from 'antd/lib/divider';
import commitIcon from '../../../assets/commit-icon.svg';

interface CommitInfoModuleProps {
    commitLabel: string;
    commit?: string;
    commitMessage?: string;
    commitAuthor?: string;
    branch?: string;
}

const CommitInfoModule: React.FC<CommitInfoModuleProps> = (props: CommitInfoModuleProps) => {
    const codeTextStyle: React.CSSProperties = {
        fontFamily: 'monospace',
    };

    const titleTextStyle: React.CSSProperties = {
        ...titleStyle,
        color: antGrey.grey7,
        fontSize: 12,
    };

    return (
        <div style={{ ...releaseStepDetailsContainerModuleStyle, backgroundColor: antGrey.grey2 }}>
            <Space
                split={<Divider type="vertical" style={{ height: '100%', backgroundColor: antGrey.grey5 }} />}
                style={{
                    alignItems: 'stretch',
                    width: '100%',
                }}
                size={16}
                className="commit-info"
            >
                <Space direction="vertical" size={12}>
                    <Text style={{ ...titleTextStyle }}>Branch</Text>
                    <Space>
                        <BranchesOutlined style={{ color: antGrey.grey7 }} />
                        <Text style={codeTextStyle} ellipsis>
                            {props.branch ?? 'No branch'}
                        </Text>
                    </Space>
                </Space>
                <Space direction="vertical" size={12}>
                    <Text style={{ ...titleTextStyle, color: antGrey.grey7 }}>{props.commitLabel}</Text>
                    <Space>
                        <img src={commitIcon} />
                        <Text style={codeTextStyle} ellipsis>
                            {shortCommitHashFromHash(props.commit) ?? 'No commit'}
                        </Text>
                    </Space>
                </Space>
                <Space direction="vertical" size={12} style={{ width: '100%' }}>
                    <Text style={{ ...titleTextStyle, color: antGrey.grey7 }}>Message</Text>
                    <Space align="center" style={{ width: '100%' }}>
                        {props.commitAuthor && (
                            <Tooltip title={props.commitAuthor}>
                                <Avatar
                                    style={{
                                        backgroundColor: getAvatarColorForName(props.commitAuthor),
                                        fontSize: 10,
                                    }}
                                    size={24}
                                >
                                    {props.commitAuthor.charAt(0).toUpperCase()}
                                </Avatar>
                            </Tooltip>
                        )}
                        <Text style={{ ...codeTextStyle, direction: 'ltr' }} ellipsis>
                            {props.commitMessage ?? 'No message'}
                        </Text>
                    </Space>
                </Space>
            </Space>
        </div>
    );
};

export default CommitInfoModule;
